module.exports = __webpack_public_path__ + "img/logoHeader.png";